module.exports = __webpack_public_path__ + "prod/1.42.2/img/arrange-bg.3f08d0f6.png";